import { Building2, User as UserIcon } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { LockedInfoBox } from "./LockedInfoBox";

/** Caixa imutável — mostra de qual organização ativa a ação está saindo. Só leitura. */
export function OrganizationOriginBox({
  label = "Pedido será feito por",
  shortLabel = "Por",
}: {
  label?: string;
  shortLabel?: string;
}) {
  const { user } = useAuth();
  const org = user?.activeOrganization;
  if (!org) return null;

  return (
    <LockedInfoBox
      icon={org.isPersonal ? UserIcon : Building2}
      label={label}
      shortLabel={shortLabel}
      value={org.name}
    />
  );
}
